<div class="add-flavor-container">
  <div class="create-container" [class.open]="showForm" [formGroup]="flavorForm">
    <div class="form-row horizontal">

      <div class="form-fields">
        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'admin.flavor-management.forms.labels.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'admin.flavor-management.forms.labels.flavorName' | translate }}</mat-label>
          <input matInput formControlName="flavorName" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="field wide-field fixed-height">
          <mat-label>{{ 'admin.flavor-management.forms.labels.instructions' | translate }}</mat-label>
          <textarea matInput class="no-resize fixed-textarea" formControlName="updateInstructions"
            maxlength="2000"></textarea>
        </mat-form-field>
      </div>

      <div class="form-options">
        <div class="checkbox-group vertical">
          <mat-checkbox formControlName="requiresFile">{{ 'admin.flavor-management.forms.labels.files' |
            translate}}</mat-checkbox>
          <mat-checkbox formControlName="requiresVersionCode">{{'admin.flavor-management.forms.labels.versionCode' |
            translate }}</mat-checkbox>
        </div>
      </div>

      <div class="form-conditional">
        <mat-form-field appearance="outline" class="field medium-field">
          <mat-label>{{ 'admin.flavor-management.forms.labels.fileTypes' | translate }}</mat-label>
          <input matInput formControlName="fileAccept" [disabled]="!flavorForm.get('requiresFile')?.value" />
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button mat-flat-button class="btn-yes-wizard" (click)="saveFlavor()">
          {{ 'admin.flavor-management.forms.buttons.create' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="add-flavor-actions">
    <button mat-flat-button class="btn-yes-wizard" *ngIf="!showForm" (click)="showForm = true">
      {{ 'admin.flavor-management.forms.buttons.addFlavor' | translate }}
    </button>
    <button mat-flat-button color="warn" *ngIf="showForm" (click)="resetForm(); showForm = false">
      {{ 'admin.flavor-management.forms.buttons.cancel' | translate }}
    </button>
  </div>

</div>

<div class="table-container">
  <table mat-table [dataSource]="flavors" class="mat-elevation-z8 flavors-table">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.name' | translate }}</th>
      <td mat-cell *matCellDef="let f">
        <span *ngIf="editingRowId !== f.id">{{ f.name }}</span>

        <div *ngIf="editingRowId === f.id" [formGroup]="editingRowForm[f.id]">
          <mat-form-field appearance="outline" class="field fixed-height">
            <input matInput formControlName="name" />
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="flavorName">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.flavor' | translate }}</th>
      <td mat-cell *matCellDef="let f">
        <span *ngIf="editingRowId !== f.id">{{ f.flavorName }}</span>

        <div *ngIf="editingRowId === f.id" [formGroup]="editingRowForm[f.id]">
          <mat-form-field appearance="outline" class="field fixed-height">
            <input matInput formControlName="flavorName" />
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="updateInstructions">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.instructions' | translate }}</th>
      <td mat-cell *matCellDef="let f">
        <span *ngIf="editingRowId !== f.id" class="ellipsis" matTooltip="{{ f.updateInstructions }}">
          {{ f.updateInstructions || '—' }}
        </span>

        <div *ngIf="editingRowId === f.id" [formGroup]="editingRowForm[f.id]">
          <mat-form-field appearance="outline" class="field fixed-height wide-field">
            <textarea matInput rows="1" class="fixed-textarea" formControlName="updateInstructions"
              maxlength="2000"></textarea>
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="requiresFile">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.file' | translate }}</th>
      <td mat-cell *matCellDef="let f">
        <span *ngIf="editingRowId !== f.id">
          {{ f.requiresFile ? ('admin.flavor-management.table.values.yes' | translate) :
          ('admin.flavor-management.table.values.no' | translate) }}
        </span>

        <div *ngIf="editingRowId === f.id" [formGroup]="editingRowForm[f.id]" class="checkbox-group vertical">
          <mat-checkbox formControlName="requiresFile">
            {{ 'admin.flavor-management.forms.labels.files' | translate }}
          </mat-checkbox>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="requiresVersionCode">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.versionCode' | translate }}</th>
      <td mat-cell *matCellDef="let f">
        <span *ngIf="editingRowId !== f.id">
          {{ f.requiresVersionCode ? ('admin.flavor-management.table.values.yes' | translate) :
          ('admin.flavor-management.table.values.no' | translate) }}
        </span>

        <div *ngIf="editingRowId === f.id" [formGroup]="editingRowForm[f.id]" class="checkbox-group vertical">
          <mat-checkbox formControlName="requiresVersionCode">
            {{ 'admin.flavor-management.forms.labels.versionCode' | translate }}
          </mat-checkbox>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="fileAccept">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'admin.flavor-management.table.columns.fileTypes' | translate }}
      </th>
      <td mat-cell *matCellDef="let f">
        <span *ngIf="editingRowId !== f.id">{{ f.fileAccept || '—' }}</span>
        <div *ngIf="editingRowId === f.id" [formGroup]="editingRowForm[f.id]">
          <mat-form-field appearance="outline" class="field fixed-height medium-field">
            <input matInput formControlName="fileAccept" />
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.status' | translate }}</th>
      <td mat-cell *matCellDef="let f">
        <span [ngClass]="{
          'status-active': f.active,
          'status-inactive': !f.active
        }">
          {{ f.active ? ('admin.flavor-management.table.values.active' | translate) :
          ('admin.flavor-management.table.values.inactive' | translate)}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.creationDate' | translate }}</th>
      <td mat-cell *matCellDef="let f">
        {{ f.createdAt | date:'short' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{ 'admin.flavor-management.table.columns.actions' | translate }}</th>
      <td mat-cell *matCellDef="let f" class="actions-cell">
        <div class="form-actions">
          <ng-container *ngIf="editingRowId !== f.id">
            <button mat-icon-button [matTooltip]="'admin.flavor-management.table.tooltips.edit' | translate"
              (click)="startEditing(f)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button
              [matTooltip]="f.active ? ('admin.flavor-management.table.tooltips.deactivate' | translate) : ('admin.flavor-management.table.tooltips.activate' | translate)"
              (click)="toggleActive(f)">
              <mat-icon>{{ f.active ? 'block' : 'check' }}</mat-icon>
            </button>
          </ng-container>

          <ng-container *ngIf="editingRowId === f.id">
            <button mat-icon-button [matTooltip]="'admin.flavor-management.table.tooltips.save' | translate"
              (click)="saveRow(f)">
              <mat-icon>done</mat-icon>
            </button>
            <button mat-icon-button [matTooltip]="'admin.flavor-management.table.tooltips.cancel' | translate"
              (click)="cancelRowEdit(f)">
              <mat-icon>close</mat-icon>
            </button>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.editing]="editingRowId === row.id"></tr>
  </table>
</div>